import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { PaymentSessionServiceService } from '@core/services/payment-session-service/payment-session-service.service';
import { VariantService } from '@core/services/variant/variant.service';

@Injectable({
	providedIn: 'root',
})
export class PaymentNavigationServiceService {
	constructor(
		private location: Location,
		private paymentSessionService: PaymentSessionServiceService,
		private variantService: VariantService,
	) {}

	init(): void {
		this.location.subscribe(() => {
			this.handleBrowserNavigation();
		});
	}

	private handleBrowserNavigation(): void {
		if (!this.shouldBlockShopAfterPayment()) {
			return;
		}

		this.paymentSessionService.redirectToHomePage();
		this.paymentSessionService.openOrderPaidModal();
	}

	private shouldBlockShopAfterPayment(): boolean {
		return this.variantService.isShop() && this.paymentSessionService.isPaid();
	}
}
